import React, { useEffect, useState } from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Box,
    TextField,
    Typography,
    Divider,
    Grid,
    FormControl,
    InputLabel,
    Select,
    FormHelperText,
    MenuItem,

} from '@mui/material';
import PhoneNumber from '../../sharedcomponents/PhoneNumber/phoneNumber';
import ProfileImage from '../../sharedcomponents/profileImage/profileImage';
import UploadImagePopup from '../../sharedcomponents/uploadImage/uploadImagePopup';
import pic from '../../assets/images/pic.svg';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import ParticipantAutoList from '../../sharedcomponents/participantAutoList/participantAutoList';
import { updateModuleState } from '../../stores/eventStore';
import AppConstants from '../../constants/appConstants';

const AddCredentialDialog = (props) => {
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const [credentialID, setCredentialID] = useState(0)
    const [cName, setCName] = useState('')
    const [cNameErr, setCNameErr] = useState('')
    const [cEmail, setCEmail] = useState('')
    const [cEmailErr, setCEmailErr] = useState('')
    const [cPhone, setCPhone] = useState('')
    const [cPhoneErr, setCPhoneErr] = useState('')
    const [cRelation, setCRelation] = useState('')
    const [cRelationErr, setCRelationErr] = useState('')
    const [openUpload, setOpenUpload] = useState(false)
    const [cPic, setCPic] = useState('')
    const [cPicSrc, setCPicSrc] = useState('')
    const [oldCPicSrc, setOldCPicSrc] = useState('')
    const [disableBtn, setDisableBtn] = useState(true)
    const [participant, setParticipant] = React.useState(null);
    const [cPicUrl, setCPicUrl] = useState('')
    const [relationType, setRelationType] = useState([])
    const [moduleRelationData, setModuleRelationData] = useState([])
    const [familyRelation, setFamilyRelation] = useState('')
    const [familyRelationErr, setFamilyRelationErr] = useState('')

    const onClick = (value) => {
        if (value === "cancel") {
            resetState()
            props.onCancelClick(false);
        }
        else if (value === "ok") {
            handleClick()
        }
    }
    const getEventConfig = () => {
        const moduleID = AppConstants.EVENT_MODULES.CREDENTIAL;
        ApiHelper.get(APIURLConstants.GET_EVENT_CONFIG(eventInfo.eventID))
            .then((res) => {
                let filData = res.data.filter((x) => x.moduleID == moduleID && x.key === "Relation")
                // console.log("filData", filData);
                filData && filData.map((x) => {
                    setRelationType(JSON.parse(x.description))
                })
            }).catch((err) => {
                console.log(err);
            })
    }

    const onCNameChange = (value) => {
        setCName(value)
        if (value.trim() === '') {
            setCNameErr('Please Enter Name');
        } else if (!Helper.onlyLettersAndSpacesWithHyphensAndDot(value)) {
            setCNameErr('Please Enter Valid Name');
        } else {
            setCNameErr('')
        }
        setDisableBtn(false)
    }
    const onCEmailChange = (value) => {
        setCEmail(value)
        if (value.trim() == '') {
            setCEmailErr('Please Enter Email');
        } else if (!Helper.validEmail(value)) {
            setCEmailErr('Please Enter valid Email');
        } else {
            setCEmailErr('');
        }
        setDisableBtn(false)
    }
    const onPhoneChange = (value) => {
        setCPhone(value)
        const phone = value ?? '';
        let regex = /^(\+?\d{1,3}[- ]?)?\d{11}$/;
        if (phone.trim() === '') {
            setCPhoneErr('Please Enter Phone');
        } else if (!regex.test(phone)) {
            setCPhoneErr('Please Enter Valid Phone');
        } else {
            setCPhoneErr('');
        }
        setDisableBtn(false)
    }
    const onRelationChange = (value) => {
        setCRelation(value)
        if (value === '') {
            setCRelationErr('Please Enter Relation');
        } else {
            if(value !== 'Family'){
                setFamilyRelation('')
            }
            setCRelationErr('')
        }
        setDisableBtn(false)
    }
    const onFamilyRelationChange = (value) => {
        setFamilyRelation(value)
        if (value === '') {
            setFamilyRelationErr('Please Enter Family Relation');
        } else {
            setFamilyRelationErr('')
        }
        setDisableBtn(false)
    }
    
    const handleCPicUpload = () => {
        setOpenUpload(true);
    }
    const handleClose = () => {
        setOpenUpload(false);
    }
    const changeProfilePhoto = (file) => {
        setCPic(file);
        if (file.size >= 5000000) {
            setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Image File is too big',
            });
        } else {
            setDisableBtn(false)
            setCPicSrc(URL.createObjectURL(file));
            handleClose();
        }
    };
    const isValidForm = () => {
        let isValid = true;
        if (cName.trim() == "" || cNameErr.length > 0) {
            setCNameErr("Please Enter Name")
            isValid = false;
        }
        if (cEmail.trim() == "" || cEmailErr.length > 0) {
            setCEmailErr("Please Enter Email")
            isValid = false;
        }
        if (cPhone.trim() == "" || cPhoneErr.length > 0) {
            setCPhoneErr("Please Enter Phone")
            isValid = false;
        }
        if (cRelation == "" || cRelationErr.length > 0) {
            setCRelationErr("Please Select Relation")
            isValid = false;
        }
        if ((familyRelation == "" || familyRelationErr.length > 0) && cRelation=== 'Family' ) {
            setFamilyRelationErr("Please Enter Family Relation")
            isValid = false;
        }
        if ((cPic === null || cPic === "") && credentialID == 0) {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please Select Photo',
            });
            isValid = false;
        }
        // console.log("isValid", isValid);
        return isValid
    }
    const getPicUrlFromApi = (credID) => {
        ApiHelper.get(
            APIURLConstants.GET_CREDENTIALS_PIC_URL(
                credID,
                eventInfo.eventID
            )
        )
            .then((res) => {
                // console.log("res",res);
                if (res.data) {
                    setCPic(res.data)
                    setOldCPicSrc(res.data)
                }
            }).catch((err) => {
                console.log("err", err);
            })
    }
    const getRelationData = () => {
        const moduleID = AppConstants.EVENT_MODULES.CREDENTIAL;
        ApiHelper.get(APIURLConstants.GET_MODULE_REMARKS(eventInfo.eventID, moduleID))
            .then((res) => {
                // console.log(res.data);
                if (res.data && res.data.length > 0) {
                    const parseData = JSON.parse(res.data[0].relationshipRemarks)
                    // console.log("parseData", parseData);
                    setModuleRelationData(parseData)
                } else {
                    setModuleRelationData([])
                }
            }).catch((err) => {
                console.log(err);

            })

    }
    // useEffect(() => {
    //     getRelationData()
    // },[])
    useEffect(() => {
        resetState()
        if (props.credData && (props.credData !== null || props.credData !== undefined)) {
            // console.log("props.credData", props.credData);
            const responseData = props.credData
            setCredentialID(responseData.credentialID)
            setCName(responseData.contactName)
            setCEmail(responseData.contactEmail)
            setCPhone(responseData.contactNo)
            setCRelation(responseData.relation)
            setFamilyRelation(responseData.familyRelation ? responseData.familyRelation : "")   
            setCPic(responseData.profilePicUrl)
            setCPicUrl(responseData.picUrl)
            setOldCPicSrc(responseData.profilePicUrl)
            const index = props.participantList && props.participantList.findIndex(
                (user) => user.userID == responseData.userID
            );
            if (index > -1) {
                setParticipant(props.participantList[index]);
            }
            getPicUrlFromApi(responseData.credentialID)
        }
        getEventConfig()
        getRelationData()
    }, [props.credData])
    const resetState = () => {
        setCName('')
        setCEmail('')
        setCPhone('')
        setCRelation('')
        setCPic('')
        setCPicSrc('')
        setParticipant(null)
        setCRelationErr('')
        setCNameErr('')
        setCEmailErr('')
        setCPhoneErr('')
    }
    // console.log("credentialID",credentialID);
    const handleClick = () => {
        const gUserInfo = Helper.getStorage('userInfo');

        // console.log(cPic, oldCPicSrc);
        if (!isValidForm()) {
            setDisableBtn(false)
        } else {
            let validCount = props.validateUsedCount(cRelation)            
            if(validCount){
                setDisableBtn(true)
                const documentData = new FormData();
                documentData.append('credentialID', credentialID > 0 ? credentialID : 0);
                documentData.append('eventID', eventInfo.eventID);
                documentData.append('userID', participant && participant ? participant.userID : userInfo.userID);
                documentData.append('contactName', cName);
                documentData.append('contactEmail', cEmail);
                documentData.append('contactNo', cPhone);
                documentData.append('relation', cRelation);
                documentData.append('familyRelation', familyRelation ? familyRelation :"");            
                documentData.append('profilePic', cPic);
                // documentData.append('profilePicUrl', cPic && cPic ? cPic.name : "");
                documentData.append('picUrl', cPic && cPic ? cPic.name ? cPic.name : cPicUrl : "");
                documentData.append('oldPicUrl', oldCPicSrc);
                documentData.append('createdBy', gUserInfo.userID);
                // console.log(documentData);
                ApiHelper.post(APIURLConstants.POST_CREDENTIALS, documentData)
                    .then(async (res) => {
                        // console.log("res", res.data);  
                        if (res.data) {
                            resetState()
                            setCredentialID(0)
                            await updateModuleState();
                            props.onCancelClick(false);
                            props.getAdminCredentialsRequestList()
                            props.setSnackBarProps({
                                ...props.snackBarProps,
                                openSnack: true,
                                variant: 'success',
                                message: credentialID > 0 ? 'Credentials Updated' : 'Credentials added',
                            });
                        }
                    }).catch((err) => {
                        console.log(err);
                        resetState()
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Error while creating request',
                        });
                        props.onCancelClick(false);
                    })
            }else{
                return false
            }
            
        }

    }
    const changeParticipant = (participant) => {
        // if (participant) {
        //     resetState();
        //     // const [lastName, firstName] = [...participant.name.split(', ')];
        //     // setCName(participant.name.replace(',','')); 
        // } else {
        //     setCName(''); 
        //     resetState();
        // }
        // fetchEventConfig(participant);
        setDisableBtn(false)
        setParticipant(participant);
    };
    return (
        <div>
            <Dialog id="addCredentialDialog"
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth={'lg'}
            >
                <DialogTitle id="alert-dialog-title">
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={30}
                        fontWeight={700}
                        fontFamily={'Action NBA'}
                        noWrap
                        fontStyle="normal"
                        color='primary'
                        component="div"
                        sx={{
                            ml: 0,
                            pt: 2,
                            pb: 1,
                        }}
                    >Request Credentials   </Typography>
                </DialogTitle>
                <Divider
                    sx={{ mt: 1, marginRight: 0, mb: 1 }}
                    flexItem
                />
                <DialogContent>
                    <Grid
                        container
                        rowSpacing={2}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }} sx={{ mb: 1 }}>
                        <Grid item container>
                            <Grid item md={4}></Grid>
                            <Grid item xs={12} md={4}>
                                <ParticipantAutoList
                                    // disableParticipant={
                                    //     props.data && props.data
                                    //         ? true
                                    //         : false
                                    // }
                                    participant={participant}
                                    setParticipant={changeParticipant}
                                    participantList={props.participantList}
                                    modPermission={props.modPermission}
                                />
                            </Grid>
                            <Grid item md={4}></Grid>
                        </Grid>
                    </Grid>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '48%' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div>
                            <TextField
                                size="small"
                                id="outlined-required"
                                label="Full Name (First & Last)"
                                autoComplete="off"
                                value={cName}
                                onChange={(event) => {
                                    onCNameChange(event.target.value)
                                }}
                                onBlur={(event) => {
                                    onCNameChange(event.target.value)
                                }}
                                fullWidth
                                error={
                                    cNameErr.length > 0 ? true : false
                                }
                                helperText={cNameErr}
                                inputProps={{ maxLength: 50 }}
                                sx={{ pr: 1 }}
                                required={true}
                            />
                            <TextField
                                size="small"
                                id="outlined-required"
                                label="Email"
                                autoComplete="off"
                                value={cEmail}
                                onChange={(event) => {
                                    onCEmailChange(event.target.value)
                                }}
                                onBlur={(event) => {
                                    onCEmailChange(event.target.value)
                                }}
                                fullWidth
                                error={
                                    cEmailErr.length > 0 ? true : false
                                }
                                helperText={cEmailErr}
                                inputProps={{ maxLength: 50 }}
                                required={true}
                            />
                        </div>
                    </Box>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '48%' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: '47.5%', marginTop: '8px', marginLeft: '8px' }}>
                                <PhoneNumber
                                    name={'credcontact'}
                                    placeholder={'Phone'}
                                    value={cPhone}
                                    onChange={(val) => onPhoneChange(val)}
                                    required={true}
                                    helperText={cPhoneErr}
                                    error={
                                        cPhoneErr.length > 0 ? true : false
                                    }
                                />
                            </div>
                            {moduleRelationData && moduleRelationData.type === "freeText" ?
                                <TextField
                                    size="small"
                                    id="outlined-required"
                                    label="Relation Type*"
                                    autoComplete="off"
                                    value={cRelation}
                                    onChange={(event) => {
                                        onRelationChange(event.target.value)
                                    }}
                                    onBlur={(event) => {
                                        onRelationChange(event.target.value)
                                    }}
                                    fullWidth
                                    error={
                                        cRelationErr.length > 0 ? true : false
                                    }
                                    helperText={cRelationErr}
                                    inputProps={{ maxLength: 50 }}
                                    sx={{ ml: '24px !important' }}
                                /> :
                                <>
                                <FormControl size="small" sx={{ ml: '24px !important', width: '48%', mt: 1 }}>
                                    <InputLabel id="demo-simple-select-label">
                                        Relation Type*
                                    </InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={cRelation}
                                        error={
                                            cRelationErr.length > 0 ? true : false
                                        }
                                        label={'Relation Type'}
                                        onChange={(event) => { onRelationChange(event.target.value) }}>
                                        {moduleRelationData && moduleRelationData.options && moduleRelationData.options.length > 0 && moduleRelationData.options.map((item, i) => {
                                            if (item.value != "") {
                                                return (
                                                    <MenuItem
                                                        key={`relation_${i}`}
                                                        value={item.value}>
                                                        {item.value}
                                                    </MenuItem>
                                                )
                                            }
                                        }
                                        )}
                                    </Select>
                                    {cRelationErr.length > 0 ? <FormHelperText sx={{ color: "#da5050" }}>{cRelationErr}</FormHelperText> : ''}
                                </FormControl>
                                    {cRelation=== 'Family' ? <TextField
                                    size="small"
                                    id="outlined-required"
                                    label="Family Relation*"
                                    autoComplete="off"
                                    value={familyRelation}
                                    onChange={(event) => {
                                        onFamilyRelationChange(event.target.value.trim())
                                    }}
                                    onBlur={(event) => {
                                        onFamilyRelationChange(event.target.value.trim())
                                    }}
                                    fullWidth
                                    error={
                                        familyRelationErr.length > 0 ? true : false
                                    }
                                    helperText={familyRelationErr}
                                    inputProps={{ maxLength: 50 }}
                                    sx={{ ml: '24px !important'}}
                                /> : null}
                            </>}
                        </div>
                    </Box>
                    <Box
                        component="form"
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 0.5,
                            alignItems: 'center',
                            padding: 1,
                            width: 140
                        }}>
                        <Box sx={{ pb: 1 }}>Upload Photo*</Box>
                        <Box>
                            {cPicSrc ? (
                                <ProfileImage
                                    handleClick={handleCPicUpload}
                                    src={cPicSrc}
                                    width={50}
                                />
                            ) : cPic ? (
                                <ProfileImage
                                    handleClick={handleCPicUpload}
                                    src={cPic}
                                    width={50}
                                />
                            ) : (
                                <ProfileImage
                                    handleClick={handleCPicUpload}
                                    src={pic}
                                    width={50}
                                />
                            )}
                        </Box>
                    </Box>

                    {/* <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '48%' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: '47.5%', marginTop: '8px', marginLeft: '8px' }}>
                            <Box sx={{ pb: 1 }}>Upload Photo*</Box>
                            <Box>
                                {cPicSrc ? (
                                    <ProfileImage
                                        handleClick={handleCPicUpload}
                                        src={cPicSrc}
                                        width={50}
                                    />
                                ) : cPic ? (
                                    <ProfileImage
                                        handleClick={handleCPicUpload}
                                        src={cPic}
                                        width={50}
                                    />
                                ) : (
                                    <ProfileImage
                                        handleClick={handleCPicUpload}
                                        src={pic}
                                        width={50}
                                    />
                                )}
                            </Box>
                            </div>
                            {moduleRelationData && moduleRelationData.type === "freeText" ?
                                null
                                :
                                cRelation=== 'Family' ? <TextField
                                    size="small"
                                    id="outlined-required"
                                    label="Family Relation*"
                                    autoComplete="off"
                                    value={familyRelation}
                                    onChange={(event) => {
                                        onFamilyRelationChange(event.target.value)
                                    }}
                                    onBlur={(event) => {
                                        onFamilyRelationChange(event.target.value)
                                    }}
                                    fullWidth
                                    error={
                                        familyRelationErr.length > 0 ? true : false
                                    }
                                    helperText={familyRelationErr}
                                    inputProps={{ maxLength: 50 }}
                                    sx={{ ml: '24px !important',  mt: '16px !important' }}
                                /> : null}
                        </div>
                    </Box>  */}
                    {openUpload && (
                        <UploadImagePopup
                            open={openUpload}
                            title="Upload Image"
                            handleClose={handleClose}
                            changeProfilePhoto={changeProfilePhoto}
                            snackBarProps={props.snackBarProps}
                            setSnackBarProps={props.setSnackBarProps}
                            showExtraDescription={true}
                        />
                    )}
                </DialogContent>
                <Divider
                    sx={{ mt: 1, marginRight: 0, mb: 1 }}
                    flexItem
                />
                <DialogActions>
                    <Button onClick={() => onClick("cancel")} color="primary" variant="outlined" >
                        {props.CancelButtonText}
                    </Button>
                    <Button onClick={() => onClick("ok")} color="primary" variant="contained" autoFocus disabled={disableBtn}>
                        {props.OkButtonText}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default AddCredentialDialog;

AddCredentialDialog.defaultProps = {
    CancelButtonText: "Cancel",
    OkButtonText: "OK",
    title: '',
    message: ''
}
